export default __webpack_public_path__ + "static/reed-2-af6ae3bf5e67a53f8386cf7ae50e55c1.webp";